module.exports = __webpack_public_path__ + "static/media/pavanastudio.4156aaca.png";